import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { AppStoreLogoComponent, GooglePlayLogoComponent } from '@core/ui';
import { CrntVisuallyHidden } from '@essent/current-web-angular';
import { LinkField } from '@sitecore-jss/sitecore-jss-angular';
import { TrackLinkDirective } from '@analytics/events';

@Component({
  selector: 'wl-app-store-buttons',
  standalone: true,
  imports: [
    AppStoreLogoComponent,
    GooglePlayLogoComponent,
    CrntVisuallyHidden,
    NgClass,
    TrackLinkDirective,
  ],
  styleUrls: [
    './app-store-buttons.component.essent.scss',
    './app-store-buttons.component.ed.scss',
  ],
  templateUrl: './app-store-buttons.component.html',
})
export class AppStoreButtonsComponent {
  readonly appStoreButtonLink = input.required<LinkField>();
  readonly googlePlayButtonLink = input.required<LinkField>();

  readonly displayColumn = input<'sm' | 'md' | 'lg'>();
  readonly inverted = input<boolean>();
}
